<template>
  <div class="container">
    <div class="top-box">
      <div class="content">
        <div class="Description">
          <div class="fr-box">
            <div>
              <img :src="data.logo" alt />
            </div>
            <div>
              <h1>
                <p class="types">{{data.name}}</p>{{data.title}}
              </h1>
              <p class="dpContent">
                {{data.sub_title}}
              </p>s
            </div>
          </div>
          <p class="time">
            <span>上线时间</span>
            <br />{{data.online_time}}
          </p>
          <div class="icon-box">
            <div v-for="item in data.icon" :key="item.id">
              <img :src="item.pic_url" alt />
              <p class="icon-p">{{item.title}}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="show">
      <h1>案例展示</h1>
      <div class="caseimg">
        <img :src="data.detail" alt />
      </div>
    </div>
    <div class="other">
      <div class="otherCase">
        <h1>其它推荐</h1>
        <div class="caseBox">
          <div class="caseitem" v-for="item in recommend" :key="item.id" @click="toPage({name:'details',query:{id:item.id}}),refresh()">
              <div>
                <img :src="item.pic_url" alt="">
              </div>
              <p>{{item.title}}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from '../utils/axios';
export default {
  data(){
    return{
      data: [],
      recommend: []
    }
  },
  methods: {
    async getcasexq(){
      let id = this.$route.query.id;
      let from = this.$route.query.from;
      let param = { id: id, safecode: "slgapicode" };
      await axios.fetchPost("/project/projectDetail", param).then(data => {
      this.data = data.data.data.data
      this.recommend = data.data.data.recommend
      console.log(this.recommend)
      });
    },
    toPage(url) {
      this.$router.push(url);
    },
    refresh() {
      this.$router.go(0);
    }
  },
  mounted() {
    this.getcasexq();
  }
}
</script>
<style lang="less" scoped>
.container {
  background-color: #2445a6;
  .top-box {
    width: 100%;
    background-image: url("../assets/img/xqbg.png");
    background-repeat: no-repeat;
    background-size: 100% auto;
    height: 500px;
    .content {
      width: 1200px;
      margin: auto;
      position: relative;
      .Description {
        padding-top: 160px;
        width: 920px;
        .fr-box {
          display: flex;
          align-items: center;
          img {
            width: 94px;
            height: 94px;
            margin-right: 40px;
            margin-top: -10px;
          }
          h1 {
            font-family: SourceHanSansCN-Medium;
            font-size: 26px;
            color: white;
            display: flex;
            align-items: center;
            margin: 0;
            .types {
              width: 120px;
              height: 32px;
              background-image: url("../assets/img/types.png");
              background-repeat: no-repeat;
              background-size: 100% 100%;
              font-size: 12px;
              font-family: SourceHanSansCN-Medium;
              text-align: center;
              line-height: 32px;
              margin-right: 20px !important;
              margin: 0;
            }
          }
          .dpContent {
            color: #a3bdff;
            font-family: SourceHanSansCN-Medium;
            line-height: 30px;
            overflow: hidden;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            text-overflow: ellipsis;
            -webkit-line-clamp: 2; /*限制行数为2行*/
            line-clamp: 2; /*限制行数为2行*/
            text-align: justify !important;
          }
        }
        .time {
          position: absolute;
          right: 0;
          top: 140px;
          font-size: 16px;
          font-family: Source Han Sans CN;
          font-weight: 500;
          line-height: 30px;
          color: #a3bdff;
          span {
            color: rgba(255, 255, 255, 1);
          }
        }
        .icon-box {
          display: flex;
          flex-wrap: wrap;
          div {
            box-sizing: border-box;
            background-color: #243e9f;
            position: relative;
            height: 110px;
            width: 110px;
            text-align: center;
            box-sizing: border-box;
            padding: 5px 5px 10px 5px;
            border: #5c79e0 1px solid;
            margin-right: 10px;
            img {
              width: 80px;
              height: 80px;
            }
            .icon-p {
              color: #c8d4ff;
              margin: 0;
              font-size: 12px;
              font-weight: normal;
              margin-top: -15px;
              overflow: hidden;
              display: -webkit-box;
              -webkit-box-orient: vertical;
              text-overflow: ellipsis;
              -webkit-line-clamp: 1; /*限制行数为2行*/
              line-clamp: 1; /*限制行数为2行*/
            }
          }
          div:hover {
            background-color: #2445a6;
          }
        }
      }
    }
  }
  .show {
    width: 100%;
    background-color: #243e9f;
    padding-bottom: 60px;
    padding-top: 60px;
    h1{
        color: white;
        text-align: center;
        font-family: SourceHanSansCN-Medium;
        font-size: 24px;
        font-weight: 500;
        margin-bottom: 40px !important;
      }
    .caseimg {
      width: 1200px;
      margin: auto;
      overflow-y: hidden;
      overflow-x: scroll;
      border: #5175EC 8px solid;
      border-radius: 30px;
      background-color: white;
      box-sizing: border-box;
      img{
        height: 500px;
      }
    }
    .caseimg::-webkit-scrollbar {
      /*滚动条整体样式*/
      width: 10px; /*高宽分别对应横竖滚动条的尺寸*/
      height: 10px;
    }
    .caseimg::-webkit-scrollbar-thumb {
      /*滚动条里面小方块*/
      border-radius: 10px;
      background-color: skyblue;
    }
    .caseimg::-webkit-scrollbar-track {
      /*滚动条里面轨道*/
      border-radius: 10px;
      background: none;
    }
  }
  .other{
    width: 100%;
    background-color: #2445A6;
    .otherCase{
      width: 1200px;
      margin: auto;
      padding: 60px 0;
      h1{
        color: white;
        text-align: center;
        font-family: SourceHanSansCN-Medium;
        font-size: 24px;
        font-weight: 500;
        margin-bottom: 40px !important;
      }
      .caseBox{
        display: flex;
        align-items: center;
        justify-content: center;
        .caseitem{
          width: 280px;
          height: 340px;
          margin-right: 15px;
          cursor: pointer;
          div{
            height: 280px;
            width: 280px;
            overflow: hidden;
            img{
            width: 280px;
            height: 280px;
            transition: all 0.6s;
            }
            img:hover{
              transform: scale(1.2);
            }
          }
          p{
            text-align: center;
            color: white;
            font-size: 16px;
            font-family: SourceHanSansCN-Medium;
          }
        }
        .caseitem:nth-child(4){
          margin-right: 0 !important;
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/details.vue